module.exports = __webpack_public_path__ + "img/instagram.116ad97.svg";